import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const useArticleStoryGet = (contentId) => {
  let resource = `${MONOLITH_ORIGIN}/api/v2/articlestory/`;
  const params = { content_id: contentId, include_article_levels: true };
  const queryString = new URLSearchParams(params).toString();
  resource = `${resource}?${queryString}`;
  return useRestQuery(resource, { skip: !contentId });
};

export default useArticleStoryGet;
